export interface ApiErrorBody {
  message?: string;
  reason?: string;
}

export interface ApiRequestErrorOptions {
  status?: number;
  body?: ApiErrorBody;
  isNetworkError?: boolean;
  isTimeout?: boolean;
}

/** Typed API failure used by both fake and future real clients. */
export class ApiRequestError extends Error {
  readonly status?: number;
  readonly body?: ApiErrorBody;
  readonly isNetworkError: boolean;
  readonly isTimeout: boolean;

  constructor(message: string, options: ApiRequestErrorOptions = {}) {
    super(message);
    this.name = 'ApiRequestError';
    this.status = options.status;
    this.body = options.body;
    this.isNetworkError = options.isNetworkError ?? false;
    this.isTimeout = options.isTimeout ?? false;
  }
}
